export default "__VITE_ASSET__DRdbExVz__"